import { css } from "@emotion/core";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

export const rootStyle = css`
  ${MEDIA_QUERY_FOR_PC} {
    padding-block: 80px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    padding-block: 60px;
  }
`;

export const divStyle = css`
  & + & {
    ${MEDIA_QUERY_FOR_PC} {
      margin-top: 80px;
    }

    ${MEDIA_QUERY_FOR_SP} {
      margin-top: 60px;
    }
  }
`;
